const { passwordStrength } = require('check-password-strength');

export const validateEmail = (emai) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(emai)) {
        return true;
    }

    return false;
};

export const validateRSANumber = (number) => {
    if (number.length !== 10 || isNaN(number)) {
        return false;
    }

    return true;
};

export const validateIdNumber = (value) => {
    const validateIdFormat =
        /(?<Year>[0-9][0-9])(?<Month>([0][1-9])|([1][0-2]))(?<Day>([0][1-9])|([1-2][0-9])|([3][0-1]))(?<Gender>[0-9])(?<Series>[0-9]{3})(?<Citizenship>[0-1])(?<Uniform>[8])(?<Control>[0-9])/;

    // Apply Luhn's algorithm on the last digit
    let checkSum = 0;
    let isEvenIndex = false;
    const idNumber = value ? value.toString().replace(/\D/g, '') : '';
    for (let n = idNumber.length - 1; n >= 0; n = n - 1) {
        const index = idNumber.charAt(n);
        let idNumberDigit = parseInt(index, 10);
        if (isEvenIndex) {
            idNumberDigit = idNumberDigit * 2;
            if (idNumberDigit > 9) {
                idNumberDigit = idNumberDigit - 9;
            }
        }
        checkSum = checkSum + idNumberDigit;
        isEvenIndex = !isEvenIndex;
    }
    if (checkSum % 10 === 0 && validateIdFormat.test(idNumber)) {
        return true;
    }
    return false;
};

export const validatePassword = (password) => {
    const strength = passwordStrength(password);

    return strength;
};

export const validatePasswordMatch = (password, confirmPassword) => {
    if (password === confirmPassword) {
        return true;
    }

    return false;
};
